import { render, staticRenderFns } from "./CoinContainer.vue?vue&type=template&id=6e74c2dd&scoped=true&"
import script from "./CoinContainer.vue?vue&type=script&lang=js&"
export * from "./CoinContainer.vue?vue&type=script&lang=js&"
import style0 from "./CoinContainer.vue?vue&type=style&index=0&id=6e74c2dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e74c2dd",
  null
  
)

export default component.exports